document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll(
    '[data-section-type="product-related"]',
  );

  sections.forEach((section) => {
    const sectionId = section.dataset.sectionId;

    if (!sectionId) {
      console.warn('Product Related: Section ID not found');
      return;
    }

    const isRecommendations = section.classList.contains('product-recommended');

    const initSwiper = () => {
      const productRows = section.querySelectorAll('.product-row__products');
      productRows.forEach((row) => {
        new Swiper(row.querySelector('.swiper'), {
          slidesPerView: 1,
          spaceBetween: 10,
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 0,
            },
          },
          navigation: {
            nextEl: row.querySelector('.swiper-button-next'),
            prevEl: row.querySelector('.swiper-button-prev'),
          },
        });
      });
    };

    const initCategoryToggle = () => {
      const categoryButtons = section.querySelectorAll(
        '.product-row__category',
      );
      categoryButtons.forEach((button) => {
        button.addEventListener('click', function () {
          const targetTitle = this.textContent.trim();

          // Update category buttons
          section
            .querySelectorAll('.product-row__category')
            .forEach((btn) =>
              btn.classList.remove('product-row__category--active'),
            );
          this.classList.add('product-row__category--active');

          // Update active products
          section
            .querySelectorAll('.product-row__products')
            .forEach((row) => row.classList.remove('active'));
          const targetRow = section.querySelector(
            `.product-row__products[data-title="${targetTitle}"]`,
          );
          if (targetRow) {
            targetRow.classList.add('active');
          }
        });
      });
    };

    // If using recommendations, fetch and initialize
    if (isRecommendations) {
      const url = section.dataset.url;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;

          // Find the recommendations container by looking for the active one
          const recommendedProducts = html.querySelector(
            '.product-row__products.active',
          );

          if (
            recommendedProducts &&
            recommendedProducts.innerHTML.trim().length
          ) {
            // Find target by the same data-title attribute
            const dataTitle = recommendedProducts.getAttribute('data-title');
            const targetContainer = section.querySelector(
              `.product-row__products[data-title="${dataTitle}"]`,
            );
            if (targetContainer) {
              targetContainer.innerHTML = recommendedProducts.innerHTML;
            }
            section.style.display = 'block';
            initSwiper();
            initCategoryToggle();
          } else {
            section.style.display = 'none';
          }
        })
        .catch((e) => {
          console.error('Error fetching product recommendations:', e);
          section.style.display = 'none';
        });
    } else {
      // Manual product lists only - initialize immediately
      initSwiper();
      initCategoryToggle();
    }
  });
});
